import React from 'react';
import PropTypes from 'prop-types';

const ActionButtons = ({ 
  onExportExcel, 
  onExportPDF, 
  additionalActions,
  showExport = true,
  uniqueId = "default"
}) => {
  const handleClick = (e, callback) => {
    e.preventDefault();
    callback?.();
  };

  // ✅ FIX: Only show export button if at least one export function is provided
  const hasExportCapability = onExportExcel || onExportPDF;

  return (
    <div className="d-flex gap-2">
      {showExport && hasExportCapability && (
        <div className="dropdown">
          <button type="button" id={`export-dropdown-button-${uniqueId}`} className="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" aria-label="Export options" aria-expanded="false" aria-haspopup="true">
            Export
          </button>
          <div className="dropdown-menu" role="menu" aria-labelledby={`export-dropdown-button-${uniqueId}`}>
            {onExportExcel && (
              <button className="dropdown-item" onClick={(e) => handleClick(e, onExportExcel)}>
                Export to Excel
              </button>
            )}
            {onExportPDF && (
              <button className="dropdown-item" onClick={(e) => handleClick(e, onExportPDF)}>
                Export to PDF
              </button>
            )}
          </div>
        </div>
      )}
      {additionalActions}
    </div>
  );
};

ActionButtons.propTypes = {
  onExportExcel: PropTypes.func,
  onExportPDF: PropTypes.func,
  additionalActions: PropTypes.node,
  showExport: PropTypes.bool,
  uniqueId: PropTypes.string
};

export default ActionButtons;


